"use client";

import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogBody,
    DialogFooter,
} from "../../ui/dialog";

import Button from "../../button-v1";
import TimeInput from "../../ui/timeInput/TimeInput";

import { useForm, Controller } from "react-hook-form";
import styles from "../../../styles/case-manager-modules/DecisionModal.module.css";

const ReviewModal = ({ isOpen, onClose, onSubmit }) => {
    const {
        control,
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        defaultValues: {
            note: "",
            timeSpent: {
                hh: "",
                mm: "",
                ss: "",
            },
        },
    });

    const submitHandler = (data) => {
        const { hh, mm, ss } = data.timeSpent;

        const totalMinutes =
            Number(hh || 0) * 60 +
            Number(mm || 0) +
            Math.round(Number(ss || 0) / 60);

        onSubmit({
            note: data.note,
            timeSpentMinutes: totalMinutes,
        });
    };

    return (
        <Dialog open={isOpen} setOpen={onClose}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Review Reading</DialogTitle>
                </DialogHeader>

                <form onSubmit={handleSubmit(submitHandler)}>
                    <DialogBody className={styles.body}>
                        <label className={styles.label}>
                            Clinical Review Note *
                        </label>

                        <textarea
                            className={`${styles.textarea} ${errors.note ? styles.textarea_error : ""}`}
                            {...register("note", {
                                required: "Review note is required",
                                minLength: {
                                    value: 5,
                                    message: "Minimum 5 characters required",
                                },
                            })}
                        />

                        {errors.note && (
                            <span className={styles.error}>
                                {errors.note.message}
                            </span>
                        )}

                        <label className={styles.label}>
                            Time Spent Reviewing *
                        </label>

                        <Controller
                            name="timeSpent"
                            control={control}
                            defaultValue={{ hh: "", mm: "", ss: "" }}
                            render={({ field }) => (
                                <TimeInput value={field.value} onChange={field.onChange} />
                            )}
                        />


                        {errors.timeSpent && (
                            <span className={styles.error}>
                                {errors.timeSpent.message}
                            </span>
                        )}
                    </DialogBody>

                    <DialogFooter className={styles.actions}>
                        <Button variant="primary" type="submit">
                            Mark as Reviewed
                        </Button>

                        <Button variant="ghost" type="button" onClick={onClose}>
                            Cancel
                        </Button>
                    </DialogFooter>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default ReviewModal;
